module.exports = __webpack_public_path__ + "static/media/pencil.f3c9753a.svg";